import React from "react";
import withCustomStyles from "./ProductsHorizontalSectionPart.style";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import HorizontalProductsListPart from "./HorizontalProductsListPart";
import { inject, observer } from "mobx-react";
import { getProductIdFromUrl } from "../utils/UrlUtils";

@inject(["customerStore"])
@observer
class ProductsHorizontalSectionPart extends React.Component {
  horizontalRef = React.createRef();

  componentDidMount() {
    if (typeof this.props.fetch === "function") {
      this.props.fetch();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname },
      customerStore
    } = this.props;
    let prid = getProductIdFromUrl(pathname);
    let oldPrid = getProductIdFromUrl(prevProps.location.pathname);

    if (
      (prid && oldPrid && prid !== oldPrid) ||
      customerStore.vendorId !== prevProps.customerStore.vendorId
    ) {
      this.props.cancel();
      this.props.fetch();
    }
  }

  shouldComponentUpdate(nextProps) {
    let nextPrid = getProductIdFromUrl(nextProps.location.pathname);
    let propPrid = getProductIdFromUrl(this.props.location.pathname);

    return (
      nextProps.name !== this.props.name ||
      nextProps.CTListName !== this.props.CTListName ||
      nextPrid !== propPrid ||
      JSON.stringify(nextProps.products) !==
        JSON.stringify(this.props.products) ||
      nextProps.state !== this.props.state ||
      nextProps.seeAllTo !== this.props.seeAllTo ||
      nextProps.customerStore.vendorId !== this.props.customerStore.vendorId
    );
  }

  componentWillUnmount() {
    if (typeof this.props.cancel === "function") {
      this.props.cancel();
    }
  }

  render() {
    const {
      props: {
        classes,
        name,
        state,
        products,
        onScroll,
        listName,
        CTListName,
        seeAllTo,
        id
      }
    } = this;

    if (!products || (products.length === 0 && state !== "fetching")) {
      return null;
    }

    return (
      <div id={id} className={classes.root}>
        <HorizontalProductsListPart
          horizontalRef={this.horizontalRef}
          title={name}
          seeAllTo={seeAllTo}
          onScroll={onScroll}
          state={state}
          listName={listName}
          CTListName={CTListName}
          products={products}
        />
      </div>
    );
  }
}

ProductsHorizontalSectionPart.propTypes = {
  products: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  listName: PropTypes.string,
  CTListName: PropTypes.string,
  seeAllTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string
};

export default withRouter(withCustomStyles(ProductsHorizontalSectionPart));
